import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useStyles from './style'
import TherapistDisplay from '../../components/TherapistDisplay'
import NavigationButtons from '../../components/NavigationButtons'
import { withStyles } from '@mui/styles'
import GeneralRepair from '../../tabs/generalRepair'
import Repair from '../../tabs/repair'
import { setOrderType } from '../../store/reducers/general'
import { useNavigate } from 'react-router'
import ValidationErrorDialog from '../../components/ValidationErrorDialog'

const OrderPage = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const other = useSelector(state => state.other)
    /**
     */
    useEffect(() => {
        if(other.backend.key != ""){
            dispatch(setOrderType('Reparatie'))
        } else {
            navigate('/')
        }
    }, [])

    useEffect(() => {
        if (other.allValid) {
            navigate('/overview')
        }
    }, [other.allValid, other.errorDialog])

    return (
        <div>
            <TherapistDisplay />
            <NavigationButtons />
            <GeneralRepair />
            <Repair />
            <ValidationErrorDialog />
            <NavigationButtons />
        </div>
    )
}
export default withStyles(useStyles)(OrderPage)
